define('modules/form_editor/views/preview_radio_item',['require','exports','module','base/itemview','i18n','../../editor/models/editorstate','ldsh!../templates/input_radio_item_amp','ldsh!../templates/input_radio_item'],function (require, exports, module) {
  "use strict";
  var ItemView = require("base/itemview"),
      i18n = require("i18n"),
      EditorState = require("../../editor/models/editorstate");

  module.exports = ItemView.extend({
    template: null,
    tagName: "label",
    className: "radio-inline",
    initialize: function (options) {
      this.parentModel = options.parent.model;
      this.inputName = this.parentModel.get("nameAttr");
      this.isRequired = this.parentModel.get("isRequired");
      this.elementId = this.parentModel.get("elementId") + '-' + this.model.get('text');
      this.template = EditorState.getAMPState() ?
          require("ldsh!../templates/input_radio_item_amp") : require("ldsh!../templates/input_radio_item");

    },

    helpers: function () {
      var text = this.model.get("text"),
          key = ["formEditor", "social", text].join(".");

      var radioParams = {
        inputName: this.inputName,
        isRequired: this.isRequired,
        elementId: this.elementId,
        value: this.model.get("valid") ? this.model.get("value") || text : "",
        radioText: i18n.exists(key) ? i18n.t(key) : text,
        isAMP: EditorState.getAMPState(),
        ampStateId: this.parentModel.get("ampStateId")
      };

      return radioParams;
    }
  });
});

